import { render, staticRenderFns } from "./activityMDetail.vue?vue&type=template&id=43a51499&scoped=true&"
import script from "./activityMDetail.vue?vue&type=script&lang=js&"
export * from "./activityMDetail.vue?vue&type=script&lang=js&"
import style0 from "./activityMDetail.vue?vue&type=style&index=0&id=43a51499&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a51499",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43a51499')) {
      api.createRecord('43a51499', component.options)
    } else {
      api.reload('43a51499', component.options)
    }
    module.hot.accept("./activityMDetail.vue?vue&type=template&id=43a51499&scoped=true&", function () {
      api.rerender('43a51499', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/activityManage/activityList/activityMDetail.vue"
export default component.exports